import { useReducer, useEffect } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import SystemEvaluationForm from "./pages/SystemEvaluationForm";

function AppContent() {
  const { isLoggedIn, isAdmin } = useAuth();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const handler = () => forceUpdate();
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  const hash = window.location.hash;

  // Kuesioner Kepuasan Sistem — publik, diisi validator ahli tanpa login
  if (hash === "#evaluasi-sistem") {
    return (
      <SystemEvaluationForm
        onBack={() => {
          window.location.hash = "";
        }}
      />
    );
  }

  // Sudah login sebagai admin/dokter
  if (isLoggedIn && isAdmin) return <Dashboard />;

  // Belum login
  if (hash === "#login")
    return (
      <LoginPage
        onBack={() => {
          window.location.hash = "";
        }}
      />
    );
  return (
    <LandingPage
      onLoginClick={() => {
        window.location.hash = "#login";
      }}
    />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
